import {Injectable} from "@angular/core";
import {PaymentMethodsDTO} from "@app/core/payment-method/application/payment-methods-dto";
import {UsualConditionsDTOMapper} from "@app/core/payment-method/infrastructure/mapper/usual-conditions-dto-mapper";
import {StoredCardDTOMapper} from "@app/core/payment-method/infrastructure/mapper/stored-card-dto-mapper";

@Injectable({
    providedIn: 'root'
})
export class FindPaymentMethodsWsMapper {

    private static readonly usualConditionsDTOMapper = new UsualConditionsDTOMapper();
    private static readonly storedCardDTOMapper = new StoredCardDTOMapper();

    private static readonly KEY = {
        CARDS: 'cards',
        USUAL_CONDITIONS: 'usualConditions',
    }

    map(data: Record<string, any>): PaymentMethodsDTO {

        // Cards
        const cardsData = (data[FindPaymentMethodsWsMapper.KEY.CARDS] ?? null) as Record<string, any>[] | null;
        const cards = cardsData ? cardsData.map(card => FindPaymentMethodsWsMapper.storedCardDTOMapper.map(card))  : null;

        // Usual conditions
        const usualConditionsData = (data[FindPaymentMethodsWsMapper.KEY.USUAL_CONDITIONS] ?? null) as Record<string, any> | null;
        const usualConditions = usualConditionsData ? FindPaymentMethodsWsMapper.usualConditionsDTOMapper.map(usualConditionsData) : null;

        return new PaymentMethodsDTO({
            cards: cards,
            usualConditions: usualConditions,
        });
    }
}


